const AppConstants = {
  pollWidget2Name: {
    STARS: "Rating",
    SENTIMENT: "Sentiment",
    NPS: `NPS`,
  },
};

export default AppConstants;
